const getAvailableMonitors = require('./available-monitors');
const createDefaultApolloPlugin = require('./create-default-apollo-plugin');

const getApolloPlugins = app => {
  const monitors = getAvailableMonitors();

  if (!monitors.length) return [];

  // Currently, it is just sending default monitor. Default monitor is only logging information generically.
  // But, when required multiple plugins based on monitor conditions and needs can be registered.
  const defaultPlugin = createDefaultApolloPlugin(app);
  return [defaultPlugin];
};

module.exports = getApolloPlugins;
